exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#grid-item-container {\n  display: -ms-flexbox;\n  display: flex; }\n  #grid-item-container img {\n    margin-right: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/admin-grid-item/admin-grid-item.component.scss
// module id = ../../../../../src/app/components/admin/components/shared/admin-grid-item/admin-grid-item.component.scss
// module chunks = main